//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Paper, Typography } from '@backmarket/design-system'

import IllustrationSearchEmptyResults from '@core/illustrations/IllustrationSearchEmptyResults.svg'

import translations from './NoResultsCard.translations'

export default {
  components: {
    IllustrationSearchEmptyResults,
    Paper,
    Typography,
  },
  computed: { translations: () => translations },
}
